module.exports = __webpack_public_path__ + "vue/img/ml.a3aa09ce.png";